module.exports = __webpack_public_path__ + "static/media/feature-tile-icon-04.6912d1cb.svg";